import { useState } from "react";
import Proptypes from "prop-types";
import TextButton from "@shared/v2/TextButton";
import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import LeadMatchesModal from "./LeadMatchesModal";
import { useFeatureFlags } from "../../reducers/layoutReducer/selectors";

const Name = ({ person, setLeadMatch }) => {
  const featureFlags = useFeatureFlags();
  const [loadingMatches, setLoadingMatches] = useState(false);
  const [leadLastSearchAt, setLeadLastSearchAt] = useState(person.lead_last_search_at);
  const [fetchResultsCount, setFetchResultsCount] = useState(person.fetch_results_count);
  const [leadMatchIsOpen, setLeadMatchIsOpen] = useState(false);
  const isNoName = !person.full_name?.trim();

  return (
    <div className="tw-flex tw-flex-col">
      <a
        className={`hover:tw-underline ${isNoName ? " !tw-text-gray-dark" : ""}`}
        href={person.person_path_with_query_param}
      >
        {person.name_or_no_name}
      </a>

      {loadingMatches && (
        <span className="tw-text-gray-dark tw-text-11d">Searching for id: {person.person_lead_id}</span>
      )}
      {isNoName && leadLastSearchAt && fetchResultsCount === 0 && (
        <span className="tw-text-gray-dark tw-text-11d">No matches found</span>
      )}
      {isNoName && fetchResultsCount > 0 && (
        <TextButton
          className="tw-text-start tw-px-0"
          schema="sentence"
          onClick={() => setLeadMatchIsOpen(true)}
        >
          {fetchResultsCount} match{fetchResultsCount > 1 ? "es" : ""} found
        </TextButton>
      )}

      {featureFlags.searchForDetails && !loadingMatches && isNoName && !leadLastSearchAt && (
        <TextButton
          className="tw-px-0 tw-text-start"
          isLoading={loadingMatches}
          onClick={() => {
            setLoadingMatches(true);
            caseTransformingAxios
              .get(`/api/v3/leads/${person.person_lead_id}/matches`)
              .then((res) => {
                setLoadingMatches(false);
                setLeadLastSearchAt(true);
                setFetchResultsCount(Number(res.data.leadMatches));
              })
              .catch(() => {
                setLoadingMatches(false);
              });
          }}
          schema="sentence"
        >
          Search for details
        </TextButton>
      )}
      <LeadMatchesModal
        open={leadMatchIsOpen}
        onClose={() => setLeadMatchIsOpen(false)}
        person={person}
        onContinue={setLeadMatch}
      />
    </div>
  );
};

Name.propTypes = {
  person: Proptypes.shape({
    full_name: Proptypes.string,
    person_lead_id: Proptypes.number.isRequired,
    person_path_with_query_param: Proptypes.string,
    name_or_no_name: Proptypes.string,
    fetch_results_count: Proptypes.number,
    lead_last_search_at: Proptypes.string,
  }).isRequired,
  setLeadMatch: Proptypes.func.isRequired,
};

export default Name;
